import React, { useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
 
  TableRow,
  Button,
  Box,
 
} from "@mui/material";
import { Pie, Bar } from "react-chartjs-2";
import Layout from "../components/layout/GSTlayout";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const GstAnnual = () => {
  const [annualReturnData, ] = useState({
    financialYear: "2023-24",
    businessDetails: {
      gstin: "07AATCA2146C1Z4",
      legalName: "Sample Enterprises Pvt Ltd",
      tradeNature: "Goods and Services",
    },
    suppliesSummary: {
      zeroRatedSupplies: 500000,
      exemptSupplies: 250000,
      nilRatedSupplies: 100000,
      nonGSTSupplies: 50000,
      totalTurnover: 900000,
    },
    taxLiability: {
      igst: 450000,
      cgst: 225000,
      sgst: 225000,
      cess: 50000,
    },
    inputTaxCredit: {
      inputIGST: 400000,
      inputCGST: 200000,
      inputSGST: 200000,
      reversalOfITC: 50000,
    },
    otherDetails: {
      totalAdvanceReceived: 200000,
      totalAdvancePaid: 150000,
      totalInwardSupplies: 750000,
    },
  });

  // Supplies Distribution Chart
  const suppliesDistributionData = {
    labels: ["Zero Rated", "Exempt", "Nil Rated", "Non-GST"],
    datasets: [
      {
        data: [
          annualReturnData.suppliesSummary.zeroRatedSupplies,
          annualReturnData.suppliesSummary.exemptSupplies,
          annualReturnData.suppliesSummary.nilRatedSupplies,
          annualReturnData.suppliesSummary.nonGSTSupplies,
        ],
        backgroundColor: [
          "rgba(255, 99, 132, 0.6)",
          "rgba(54, 162, 235, 0.6)",
          "rgba(255, 206, 86, 0.6)",
          "rgba(75, 192, 192, 0.6)",
        ],
      },
    ],
  };

  // Tax Liability Chart
  const taxLiabilityData = {
    labels: ["IGST", "CGST", "SGST", "CESS"],
    datasets: [
      {
        label: "Tax Liability (₹)",
        data: [
          annualReturnData.taxLiability.igst,
          annualReturnData.taxLiability.cgst,
          annualReturnData.taxLiability.sgst,
          annualReturnData.taxLiability.cess,
        ],
        backgroundColor: [
          "rgba(255, 99, 132, 0.6)",
          "rgba(54, 162, 235, 0.6)",
          "rgba(255, 206, 86, 0.6)",
          "rgba(75, 192, 192, 0.6)",
        ],
      },
    ],
  };
  return (
    <Layout>
      <Container maxWidth="xl">
        <Typography variant="h4" gutterBottom>
          GSTR-9 Annual Return
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          Financial Year: {annualReturnData.financialYear}
        </Typography>

        {/* Business Details */}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Business Details
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography>
                    GSTIN: {annualReturnData.businessDetails.gstin}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography>
                    Legal Name: {annualReturnData.businessDetails.legalName}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography>
                    Nature of Business:{" "}
                    {annualReturnData.businessDetails.tradeNature}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Supplies Summary */}
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Supplies Summary
              </Typography>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>Zero Rated Supplies</TableCell>
                    <TableCell align="right">
                      ₹
                      {annualReturnData.suppliesSummary.zeroRatedSupplies.toLocaleString()}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Exempt Supplies</TableCell>
                    <TableCell align="right">
                      ₹
                      {annualReturnData.suppliesSummary.exemptSupplies.toLocaleString()}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Nil Rated Supplies</TableCell>
                    <TableCell align="right">
                      ₹
                      {annualReturnData.suppliesSummary.nilRatedSupplies.toLocaleString()}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Non-GST Supplies</TableCell>
                    <TableCell align="right">
                      ₹
                      {annualReturnData.suppliesSummary.nonGSTSupplies.toLocaleString()}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Total Turnover</strong>
                    </TableCell>
                    <TableCell align="right">
                      <strong>
                        ₹
                        {annualReturnData.suppliesSummary.totalTurnover.toLocaleString()}
                      </strong>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Paper>
          </Grid>

          {/* Supplies Distribution Chart */}
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 2, height: "100%" }}>
              <Typography variant="h6" gutterBottom>
                Supplies Distribution
              </Typography>
              <Pie
                data={suppliesDistributionData}
                options={{
                  responsive: true,
                  plugins: {
                    legend: {
                      position: "top",
                    },
                  },
                }}
              />
            </Paper>
          </Grid>

          {/* Tax Liability */}
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Tax Liability
              </Typography>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>IGST</TableCell>
                    <TableCell align="right">
                      ₹{annualReturnData.taxLiability.igst.toLocaleString()}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>CGST</TableCell>
                    <TableCell align="right">
                      ₹{annualReturnData.taxLiability.cgst.toLocaleString()}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>SGST</TableCell>
                    <TableCell align="right">
                      ₹{annualReturnData.taxLiability.sgst.toLocaleString()}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>CESS</TableCell>
                    <TableCell align="right">
                      ₹{annualReturnData.taxLiability.cess.toLocaleString()}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Paper>
          </Grid>

          {/* Tax Liability Chart */}
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 2, height: "100%" }}>
              <Typography variant="h6" gutterBottom>
                Tax Liability Distribution
              </Typography>
              <Bar
                data={taxLiabilityData}
                options={{
                  responsive: true,
                  plugins: {
                    legend: {
                      display: false,
                    },
                  },
                  scales: {
                    y: {
                      beginAtZero: true,
                      title: {
                        display: true,
                        text: "Tax Amount (₹)",
                      },
                    },
                  },
                }}
              />
            </Paper>
          </Grid>

          {/* Input Tax Credit */}
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Input Tax Credit
              </Typography>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>Input IGST</TableCell>
                    <TableCell align="right">
                      ₹
                      {annualReturnData.inputTaxCredit.inputIGST.toLocaleString()}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Input CGST</TableCell>
                    <TableCell align="right">
                      ₹
                      {annualReturnData.inputTaxCredit.inputCGST.toLocaleString()}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Input SGST</TableCell>
                    <TableCell align="right">
                      ₹
                      {annualReturnData.inputTaxCredit.inputSGST.toLocaleString()}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Reversal of ITC</TableCell>
                    <TableCell align="right">
                      ₹
                      {annualReturnData.inputTaxCredit.reversalOfITC.toLocaleString()}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Paper>
          </Grid>

          {/* Other Details */}
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Other Financial Details
              </Typography>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>Total Advance Received</TableCell>
                    <TableCell align="right">
                      ₹
                      {annualReturnData.otherDetails.totalAdvanceReceived.toLocaleString()}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Total Advance Paid</TableCell>
                    <TableCell align="right">
                      ₹
                      {annualReturnData.otherDetails.totalAdvancePaid.toLocaleString()}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Total Inward Supplies</TableCell>
                    <TableCell align="right">
                      ₹
                      {annualReturnData.otherDetails.totalInwardSupplies.toLocaleString()}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Paper>
          </Grid>

          {/* Action Buttons */}
          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between">
              <Button variant="contained" color="primary">
                Verify Annual Return
              </Button>
              <Button variant="contained" color="secondary">
                File GSTR-9
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default GstAnnual;
